import React, { useCallback } from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarSize } from '@atlaskit/editor-common/types';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { changeAlignment } from '../editor-commands';
import { ToolbarType } from '../pm-plugins/types';
import ToolbarAlignment from './ToolbarAlignment';
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    disabled = _ref.disabled,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement,
    isToolbarReducedSpacing = _ref.isToolbarReducedSpacing,
    _ref$toolbarSize = _ref.toolbarSize,
    toolbarSize = _ref$toolbarSize === void 0 ? ToolbarSize.XXL : _ref$toolbarSize;
  var _useSharedPluginState = useSharedPluginState(api, ['alignment'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    alignmentState = _useSharedPluginState.alignmentState;
  var alignSelector = useSharedPluginStateSelector(api, 'alignment.align', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var align = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? alignSelector : alignmentState === null || alignmentState === void 0 ? void 0 : alignmentState.align;
  var isEnabledSelector = useSharedPluginStateSelector(api, 'alignment.isEnabled', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var isEnabled = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? isEnabledSelector : alignmentState === null || alignmentState === void 0 ? void 0 : alignmentState.isEnabled;
  var changeAlignmentCallback = useCallback(function (align) {
    return changeAlignment(align, api, INPUT_METHOD.TOOLBAR)(editorView.state, editorView.dispatch);
  }, [editorView, api]);
  return /*#__PURE__*/React.createElement(ToolbarAlignment, {
    align: align,
    isReducedSpacing: isToolbarReducedSpacing,
    changeAlignment: changeAlignmentCallback,
    disabled: disabled || !isEnabled,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    api: api,
    toolbarType: ToolbarType.PRIMARY,
    toolbarSize: toolbarSize
  });
}